<template>
  <v-snackbar
    top
    v-model="alert"
    content-class="pa-0"
    :color="alertType"
    :timeout="alertType !== 'success' ? -1 : timeout"
    style="top:25px">
    <v-alert
      v-model="alert"
      dense
      class="my-0"
      border="left"
      dismissible
      :prominent="alertType !== 'success'"
      :type="alertType"
      :timeout="timeout">
      {{ alertMessage }}
      <template v-if="messages && messages.length > 0">
        <div v-for="(message, i) in messages" :key="i">
          {{ message }}
        </div>
      </template>
      <template v-if="errors && errors.length > 0">
        <div v-for="(error, i) in errors" :key="i">
          {{ error }}
        </div>
      </template>
    </v-alert>
  </v-snackbar>
</template>
<script>
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'AlertBar',
  mixins: [displayAlert],
  created () {
    this.$root.$on('alertdialog', (data) => {
      this.alert = data.alert
      this.alertType = data.alertType
      this.alertMessage = data.alertMessage
      this.messages = data.messages

      if (data.timeout) {
        this.timeout = 3000
      }

      window.setTimeout(() => {
        this.timeout = -1
      }, 3100)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AlertBar.vue